<template>
  <section class="flood-relief-index">
    <div class="hero-section">
      <div class="container">
        <div class="hero-grid">
          <div>
            <p class="hero-badge">
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
              โครงการจิตอาสา · Flood Relief Mission
            </p>
            <h1 class="hero-title">
              Misi Bantu Banjir 2025<br />ช่วยเหลือผู้ประสบภัยน้ำท่วมไปด้วยกัน
            </h1>
            <p class="hero-subtitle">
              ส่งต่อพลังน้ำใจจากกลุ่มอาสาไปยังชุมชนชายแดนใต้ผ่านระบบเบิกค่าเชื้อเพลิงที่โปร่งใสและติดตามผลได้จริง
            </p>
            <a class="hero-hashtag" href="https://www.facebook.com/hashtag/cucimbb25" target="_blank" rel="noopener noreferrer">#CuCIMBB25</a>
            <!-- <div class="flex flex-wrap gap-3 mt-6 text-sm font-semibold">
              <span class="px-3 py-1 rounded-full bg-white/15">เชื่อมโยงสมาชิก · เจ้าหน้าที่</span>
              <span class="px-3 py-1 rounded-full bg-white/15">อัปเดตสถานะคำขอแบบเรียลไทม์</span>
              <span class="px-3 py-1 rounded-full bg-white/15">โปร่งใสตรวจสอบได้</span>
            </div> -->
            <div v-if="showHeroHighlights" class="hero-highlights">
              <div v-for="highlight in heroHighlights" :key="highlight.key" class="highlight-card">
                <p class="highlight-label">{{ highlight.label }}</p>
                <p class="highlight-value">{{ highlight.value }}</p>
                <p class="highlight-caption">{{ highlight.caption }}</p>
              </div>
            </div>
          </div>
          <div class="steps-wrapper">
            <div class="steps-glow"></div>
            <div class="steps-card">
              <p class="steps-heading">ขั้นตอนการร่วมภารกิจ</p>
              <ul class="steps-list">
                <li class="step-item" v-if="!logedIn">
                  <span class="step-number">1</span>
                  <p>สมัครสมาชิก platform cuci 
                    <router-link
                      :to="{ name: 'Register' }"
                      class="step-link"
                    >
                    (ถ้ายังไม่เป็นสมาชิก)
                    </router-link>
                  </p>
                </li>
                <li class="step-item" v-if="!logedIn">
                  <span class="step-number">2</span>
                  <p>ล็อกอินเข้าสู่ระบบ 
                    <router-link
                      :to="{ name: 'Login' }"
                      class="step-link"
                    >(ถ้าเป็นสมาชิกแล้ว)</router-link>
                  </p>
                </li>
                <li class="step-item">
                  <span class="step-number">
                    {{ logedIn ? 1 : 3 }}
                  </span>
                  <p>สมาชิกกรอกแบบฟอร์มขอเบิกค่าเชื้อเพลิงพร้อมแนบหลักฐานประกอบ</p>
                </li>
                <li class="step-item">
                  <span class="step-number">
                    {{ logedIn ? 2 : 4 }}
                  </span>
                  <p>เจ้าหน้าที่ตรวจสอบและอัปเดตสถานะเพื่อความโปร่งใส</p>
                </li>
                <li class="step-item">
                  <span class="step-number">
                    {{ logedIn ? 3 : 5 }}
                  </span>
                  <p>ทีมภารกิจรับการแจ้งเตือนทันทีเมื่อได้รับอนุมัติหรือมีการโอนเงิน</p>
                </li>
              </ul>
              <div class="steps-footer">
                Powered by มูลนิธิจูจีสร้างสรรค์สังคม · สนับสนุนน้ำใจคนชายแดนใต้
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-content">
      <div class="cta-grid">
        <button type="button" @click="goToForm" class="cta-button cta-teal cta-indigo">
          <div class="cta-header">
            <span class="cta-badge">สำหรับสมาชิก</span>
            <span class="cta-icon cta-icon-teal">
              <svg class="icon-svg" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
              </svg>
            </span>
          </div>
          <h3 class="cta-title">แบบฟอร์มขอเบิกค่าเชื้อเพลิง</h3>
          <p class="cta-description">กรอกข้อมูลภารกิจ อัปโหลดหลักฐาน และส่งคำขอให้เจ้าหน้าที่ตรวจสอบได้ทันที</p>
          <span class="cta-link cta-link-teal">
            เริ่มกรอกแบบฟอร์ม
            <svg class="arrow-svg" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m-6-6l6 6-6 6" />
            </svg>
          </span>
          <!-- <p class="cta-deadline">ปิดรับ ลงทะเบียน<br>8/12/68 23:59</p> -->
        </button>

        <button type="button" @click="goToStatus" class="cta-button cta-indigo">
          <div class="cta-header">
            <span class="cta-badge cta-badge-indigo">ติดตามผล</span>
            <span class="cta-icon cta-icon-indigo">
              <svg class="icon-svg" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 17v-6l-2 2m6-2h6m-3-3v6" />
              </svg>
            </span>
          </div>
          <h3 class="cta-title">ตรวจสอบสถานะคำขอ</h3>
          <p class="cta-description">ดูความคืบหน้าคำขอที่ผ่านมา ตรวจสอบผลอนุมัติ และดาวน์โหลดหลักฐานการโอน</p>
          <span class="cta-link cta-link-indigo">
            ไปยังหน้าตรวจสอบสถานะ
            <svg class="arrow-svg" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m-6-6l6 6-6 6" />
            </svg>
          </span>
        </button>

        <button type="button" @click="goToPublicSearch" class="cta-button cta-purple">
          <div class="cta-header">
            <span class="cta-badge cta-badge-purple">ไม่ต้องล็อกอิน</span>
            <span class="cta-icon cta-icon-purple">
              <svg class="icon-svg" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </span>
          </div>
          <h3 class="cta-title">ค้นหาสถานะคำขอ</h3>
          <p class="cta-description">ตรวจสอบสถานะคำขอด้วยเบอร์โทรผู้ประสานงาน โดยไม่ต้องเป็นสมาชิก</p>
          <span class="cta-link cta-link-purple">
            ค้นหาคำขอ
            <svg class="arrow-svg" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m-6-6l6 6-6 6" />
            </svg>
          </span>
        </button>
      </div>

      <div class="summary-card">
        <div class="summary-header">
          <div>
            <h2 class="summary-title">สรุปสถานะคำขอทั้งหมด</h2>
            <p class="summary-subtitle">จำนวนคำขอและยอดเงิน (บาท)</p>
          </div>
          <div class="last-updated" v-if="formattedLastUpdated">
            อัปเดตล่าสุด: {{ formattedLastUpdated }}
          </div>
        </div>

        <div v-if="summaryError" class="error-box">
          {{ summaryError }}
          <button type="button" class="error-retry" @click="fetchSummary">
            ลองอีกครั้ง
            <svg class="retry-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v6h6M20 20v-6h-6M5 19A9 9 0 0119 5" />
            </svg>
          </button>
        </div>

        <div v-else>
          <div v-if="summaryLoading" class="loading-grid">
            <div v-for="n in 3" :key="n" class="loading-skeleton"></div>
          </div>
          <template v-else>
            <div class="overall-cards">
              <div v-for="card in overallCards" :key="card.key" class="overall-card" :class="card.gradient">
                <p class="overall-label">{{ card.label }}</p>
                <p class="overall-primary">{{ card.primary }}</p>
                <p class="overall-subtitle">{{ card.subtitle }}</p>
              </div>
            </div>

            <!-- <div class="pt-6 mt-6 border-t border-gray-100">
              <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
                <h3 class="text-xl font-semibold text-gray-900">จำนวนคำขอตามจังหวัด</h3>
                <p class="text-sm text-gray-500">ปัตตานี · ยะลา · นราธิวาส · สงขลา · อื่นๆ</p>
              </div>
              <div class="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
                <div v-for="province in provinceCards" :key="province.key" class="p-5 bg-white border rounded-2xl shadow-sm" :class="province.borderClass">
                  <div class="flex items-center justify-between">
                    <div>
                      <p class="text-sm font-semibold text-gray-500">จังหวัด</p>
                      <h4 class="text-xl font-bold text-gray-900">{{ province.label }}</h4>
                    </div>
                    <span class="px-3 py-1 text-sm font-semibold rounded-full" :class="province.badgeClass">
                      {{ formatNumber(province.total_requests) }} คำขอ
                    </span>
                  </div>
                  <p class="mt-2 text-sm text-gray-500">ยอดคำขอรวม ฿{{ formatCurrency(province.total_amount) }}</p>
                  <div class="grid gap-3 mt-4 sm:grid-cols-2">
                    <div v-for="statusKey in statusOrder" :key="statusKey" class="p-3 rounded-xl bg-gray-50">
                      <p class="text-xs font-semibold text-gray-500">{{ statusMeta[statusKey].label }}</p>
                      <p class="mt-1 text-lg font-bold" :class="statusMeta[statusKey].textClass">
                        {{ formatNumber(province[statusKey]) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FloodReliefMissionService from '@/services/FloodReliefMissionService'

const numberFormatter = new Intl.NumberFormat('th-TH')
const currencyFormatter = new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const defaultSummary = () => ({
  total_requests: 0,
  total_amount: 0,
  approved_requests: 0,
  approved_amount: 0,
  pending_requests: 0,
  pending_amount: 0,
  rejected_requests: 0,
  rejected_amount: 0,
  evidence_needed_requests: 0,
  evidence_needed_amount: 0,
  last_updated: null
})

export default {
  name: 'FloodReliefMissionIndex',
  data() {
    return {
      summaryLoading: false,
      summaryError: null,
      summary: defaultSummary(),
      showHeroHighlights: false
    }
  },
  computed: {
    logedIn(){
      return this.$store.getters['authMember/logedIn']
    },
    heroHighlights() {
      return [
        {
          key: 'total_requests',
          label: 'คำขอที่ส่งแล้ว',
          value: this.formatNumber(this.summary.total_requests),
          caption: 'สนับสนุนโดยสมาชิกจิตอาสา'
        },
        {
          key: 'total_amount',
          label: 'ยอดคำขอรวม (บาท)',
          value: `฿${this.formatCurrency(this.summary.total_amount)}`,
          caption: 'รวมทุกสถานะ'
        }
      ]
    },
    overallCards() {
      const data = this.summary
      return [
        {
          key: 'total',
          label: 'คำขอทั้งหมด',
          primary: this.formatNumber(data.total_requests),
          subtitle: `ยอดรวม ฿${this.formatCurrency(data.total_amount)}`,
          gradient: 'from-teal-500 to-cyan-500'
        },
        {
          key: 'pending',
          label: 'รอตรวจสอบ',
          primary: this.formatNumber(data.pending_requests) + ' คำขอ',
          subtitle: `฿${this.formatCurrency(data.pending_amount)}`,
          gradient: 'from-amber-500 to-orange-500'
        },
        {
          key: 'approved',
          label: 'คำขอที่อนุมัติแล้ว',
          primary: `${this.formatNumber(data.approved_requests)} คำขอ`,
          subtitle: `ยอดรวม ฿${this.formatCurrency(data.approved_amount)}`,
          gradient: 'from-emerald-500 to-teal-500'
        },
        // {
        //   key: 'rejected',
        //   label: 'คำขอที่ไม่อนุมัติ',
        //   primary: `${this.formatNumber(data.rejected_requests)} คำขอ`,
        //   subtitle: `ยอดรวม ฿${this.formatCurrency(data.rejected_amount)}`,
        //   gradient: 'from-red-500 to-pink-500'
        // },
        {
          key: 'evidence_needed',
          label: 'คำขอที่ต้องการหลักฐานเพิ่ม',
          primary: `${this.formatNumber(data.evidence_needed_requests)} คำขอ`,
          subtitle: `ยอดรวม ฿${this.formatCurrency(data.evidence_needed_amount)}`,
          gradient: 'from-amber-500 to-yellow-500'
        },
      ]
    },
    formattedLastUpdated() {
      if (!this.summary.last_updated) {
        return null
      }
      const date = new Date(this.summary.last_updated)
      return date.toLocaleString('th-TH', { dateStyle: 'medium', timeStyle: 'short' })
    }
  },
  mounted() {
    //scroll to top when load page
    window.scrollTo(0, 0)
    localStorage.setItem('lastVisit', 'FloodReliefMission')
    this.fetchSummary()
  },
  methods: {
    async fetchSummary() {
      this.summaryLoading = true
      this.summaryError = null
      try {
        const response = await FloodReliefMissionService.getSummary()
        const payload = response && response.data && response.data.data ? response.data.data : {}

        this.summary = {
          total_requests: payload.total_requests || 0,
          total_amount: payload.total_amount || 0,
          approved_requests: payload.approved_requests || 0,
          approved_amount: payload.approved_amount || 0,
          pending_requests: payload.pending_requests || 0,
          pending_amount: payload.pending_amount || 0,
          rejected_requests: payload.rejected_requests || 0,
          rejected_amount: payload.rejected_amount || 0,
          evidence_needed_requests: payload.evidence_needed_requests || 0,
          evidence_needed_amount: payload.evidence_needed_amount || 0,
          last_updated: payload.last_updated || null
        }
      } catch (error) {
        const fallbackMessage = 'ไม่สามารถดึงข้อมูลสรุปได้ในขณะนี้'
        if (error && error.response && error.response.data && error.response.data.message) {
          this.summaryError = error.response.data.message
        } else {
          this.summaryError = fallbackMessage
        }
      } finally {
        this.summaryLoading = false
      }
    },
    formatNumber(value) {
      return numberFormatter.format(value || 0)
    },
    formatCurrency(value) {
      return currencyFormatter.format(value || 0)
    },
    goToForm() {
      this.$router.push({ name: 'FloodReliefMissionForm' })
    },
    goToStatus() {
      this.navigateToRoute('FloodReliefMissionStatus', { name: 'FloodReliefMissionForm', query: { view: 'status' } })
    },
    goToPublicSearch() {
      this.$router.push({ name: 'FloodReliefMissionPublicStatus' })
    },
    navigateToRoute(routeName, fallbackLocation) {
      if (!routeName) {
        return
      }
      const resolved = this.$router.resolve({ name: routeName })
      if (resolved && resolved.matched && resolved.matched.length > 0) {
        this.$router.push(resolved)
      } else if (fallbackLocation) {
        this.$router.push(fallbackLocation)
      }
    }
  }
}
</script>

<style scoped>
.flood-relief-index {
  background-color: #f9fafb;
  min-height: 100vh;
  padding-top: 5rem;
}

.hero-section {
  background: linear-gradient(to right, #0d9488, #0891b2, #10b981);
  color: white;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 4rem 1rem;
}

.hero-grid {
  display: grid;
  align-items: center;
  gap: 3rem;
}

@media (min-width: 1024px) {
  .hero-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  color: #99f6e4;
  text-transform: uppercase;
}

.hero-title {
  margin-top: 1rem;
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.25;
}

@media (min-width: 768px) {
  .hero-title {
    font-size: 3rem;
  }
}

.hero-subtitle {
  margin-top: 1rem;
  font-size: 1.125rem;
  color: #a5f3fc;
}

.hero-highlights {
  display: grid;
  gap: 1rem;
  margin-top: 2rem;
}

@media (min-width: 640px) {
  .hero-highlights {
    grid-template-columns: repeat(2, 1fr);
  }
}

.highlight-card {
  padding: 1.25rem;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  background-color: rgba(255, 255, 255, 0.1);
}

.highlight-label {
  font-size: 0.875rem;
  color: rgba(165, 243, 252, 0.9);
}

.highlight-value {
  margin-top: 0.25rem;
  font-size: 1.875rem;
  font-weight: 700;
}

.highlight-caption {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: rgba(165, 243, 252, 0.8);
}

.steps-wrapper {
  position: relative;
}

.steps-glow {
  position: absolute;
  inset: 0;
  z-index: -10;
  border-radius: 9999px;
  opacity: 0.3;
  filter: blur(48px);
  background-color: rgba(52, 211, 153, 0.6);
}

.steps-card {
  position: relative;
  padding: 2rem;
  border-radius: 1.5rem;
  backdrop-filter: blur(12px);
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.steps-heading {
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.025em;
  color: #99f6e4;
  text-transform: uppercase;
}

.steps-list {
  margin-top: 1.5rem;
  color: white;
  list-style: none;
  padding: 0;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.step-item:last-child {
  margin-bottom: 0;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  font-weight: 600;
  border-radius: 9999px;
  background-color: rgba(255, 255, 255, 0.2);
}

.step-link {
  text-decoration: underline;
  color: white;
}

.steps-footer {
  margin-top: 2rem;
  font-size: 0.875rem;
  color: rgba(165, 243, 252, 0.9);
}

.main-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem 4rem;
  margin-top: -3rem;
}

.main-content > * + * {
  margin-top: 2.5rem;
}

.cta-grid {
  display: grid;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .cta-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .cta-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.cta-button {
  position: relative;
  padding: 1.5rem;
  text-align: left;
  transition: all 0.3s;
  border-radius: 1.5rem;
  background-color: white;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid #f3f4f6;
  cursor: pointer;
}

.cta-button:hover {
  transform: translateY(-0.25rem);
}

.cta-button:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(204, 251, 241, 0.5);
}

.cta-indigo:focus {
  box-shadow: 0 0 0 4px rgba(224, 231, 255, 0.5);
}

.cta-purple:focus {
  box-shadow: 0 0 0 4px rgba(233, 213, 255, 0.5);
}

.cta-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cta-badge {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #0d9488;
}

.cta-badge-indigo {
  color: #6366f1;
}

.cta-badge-purple {
  color: #8b5cf6;
}

.cta-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  color: white;
  border-radius: 9999px;
}

.cta-icon-teal {
  background: linear-gradient(to right, #14b8a6, #06b6d4);
}

.cta-icon-indigo {
  background-color: #6366f1;
}

.cta-icon-purple {
  background: linear-gradient(to right, #8b5cf6, #a855f7);
}

.icon-svg {
  width: 1.25rem;
  height: 1.25rem;
}

.cta-title {
  margin-top: 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
}

.cta-description {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.cta-link {
  display: inline-flex;
  align-items: center;
  margin-top: 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0d9488;
}

.cta-link-indigo {
  color: #6366f1;
}

.cta-link-purple {
  color: #8b5cf6;
}

.arrow-svg {
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
}

.summary-card {
  padding: 1.5rem;
  background-color: white;
  border: 1px solid #f3f4f6;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border-radius: 1.5rem;
}

@media (min-width: 768px) {
  .summary-card {
    padding: 2rem;
  }
}

.summary-card > * + * {
  margin-top: 2rem;
}

.summary-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.summary-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
}

.summary-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
}

.last-updated {
  font-size: 0.75rem;
  color: #6b7280;
}

.error-box {
  padding: 1rem;
  font-size: 0.875rem;
  color: #b91c1c;
  background-color: #fef2f2;
  border: 1px solid #fee2e2;
  border-radius: 1rem;
}

.error-retry {
  display: inline-flex;
  align-items: center;
  margin-top: 0.5rem;
  color: #dc2626;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.retry-icon {
  width: 1rem;
  height: 1rem;
  margin-left: 0.25rem;
}

.loading-grid {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .loading-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.loading-skeleton {
  height: 7rem;
  background-color: #f3f4f6;
  border-radius: 1rem;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.overall-cards {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .overall-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

.overall-card {
  padding: 1.25rem;
  transition: all 0.3s;
  border: 1px solid transparent;
  border-radius: 1rem;
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  color: #111827;
}

.overall-card.from-teal-500 {
  --tw-gradient-from: #14b8a6;
  --tw-gradient-to: #06b6d4;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  background-image: linear-gradient(to bottom right, #14b8a6, #06b6d4);
}

.overall-card.from-emerald-500 {
  background-image: linear-gradient(to bottom right, #10b981, #14b8a6);
}

.overall-card.from-amber-500 {
  background-image: linear-gradient(to bottom right, #f59e0b, #f97316);
}

.overall-card.from-indigo-500 {
  background-image: linear-gradient(to bottom right, #6366f1, #0ea5e9);
}

.overall-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
}

.overall-primary {
  margin-top: 0.5rem;
  font-size: 1.875rem;
  font-weight: 700;
  color: white;
}

.overall-subtitle {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.8);
}

.hero-hashtag {
  margin-top: 1.5rem;
  font-weight: 700;
  color: #fef08a; /* subtle yellow like screenshot */
  font-size: 1rem;
}

.cta-deadline {
  margin-top: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: #dc2626;
}

.cta-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.cta-disabled:hover {
  transform: none;
}
</style>
